// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q0-Av","label":"styles_label__2aoAE"};